//
// SubscribedFoldersManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";

var SubscribedFoldersManager = createModule("transport::SubscribedFoldersManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        shouldAllowFolderSubscription: [2],
        checkForZombies: [0],
        _subscribeToFolder_o: [1,1],
        _subscribeToFolder_s: [1,7],
        checkForUpdates: [1,1],
        updateFolderSubscriptionsStatus: [0],
        isValidFolder: [2,1],
    },
    ,
    ["subscribeToFolder"],
]);
export default SubscribedFoldersManager;
